import React, { useState, useEffect } from 'react';
import { createUser, fetchUsers, deleteUser, updateUser } from '../api';
import TextField from '@mui/material/TextField';
import SaveIcon from '@mui/icons-material/Save';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from "@mui/material/Typography";
import Stack from '@mui/material/Stack';
import AntSwitch from './AntSwitch'

import Alerts from './Alert';
import AlertDialog from './Dialog';

export default function UserForm({ user }) {
  const empty = {
    id: undefined,
    nome: "",
    login: "",
    senha: "",
    is_admin: false,
    is_funcionario: true,
    ativo: true
  };

  const [userEdit, setUserEdit] = useState(empty);
  const [users, setUsers] = useState([]);

  const [openSnack, setOpenSnack] = useState(false);
  const [snackType, setSnackType] = useState("info");
  const [snackMsg, setSnackMsg] = useState("");

  const [openDialog, setOpenDialog] = useState(false);
  const [titleDialog, setTitleDialog] = useState("info");

  const [mensagem, setMensagem] = useState("");
  const [idForDelete, setIdForDelete] = useState(null);

  const [openAccordion, setOpenAccordion] = useState(false);

  const loadUsers = async () => {
    const resp = await fetchUsers(user);
    setUsers(resp);
  };

  useEffect(() => {
    fetchUsers(user).then(data => setUsers(data));
  }, []);

  const submit = async e => {
    e.preventDefault();

    let payload = {
      ...userEdit,
      login: userEdit.login?.toLowerCase().replace(/\s+/g, "") || ""
    };

    const loginExistente = users.find(u => u.login.trim() === payload.login.trim() && u.id !== payload.id);
    if (loginExistente) {
      setSnackType("info");
      setSnackMsg("O login fornecido já existe. Por favor, utilize um login diferente.");
      setOpenSnack(true);
      return;
    }

    try {
      if (payload.id > 0) {
        await updateUser(payload.id, payload);
        setSnackMsg("Usuário atualizado com sucesso!");
      } else {
        await createUser(payload);
        setSnackMsg("Usuário criado com sucesso!");
      }

      setUserEdit(empty);
      setSnackType("success");
      setOpenSnack(true);
      await loadUsers();
    } catch (ex) {
      setSnackMsg(ex);
      setSnackType("error");
      setOpenSnack(true);
    }
  };

  const cancelEdit = () => {
    setOpenAccordion(false);
    setUserEdit(empty);
  };

  const confirmDelete = async (id) => {
    await deleteUser(id, user);
    loadUsers();
  };

  const handleDelete = async (id) => {
    setOpenDialog(true);
    setTitleDialog("Exclusão");
    setMensagem("Deseja realmente excluir este Usuário?");
    setIdForDelete(id);
  };

  const handleEdit = (userEditonClicked) => {
    setUserEdit({
      ...userEditonClicked
    });
    setOpenAccordion(true);
  };

  const handleChangeFunc = () => {
    setUserEdit({
      ...userEdit,
      is_funcionario: !userEdit.is_funcionario
    });
  };

  const handleChangeAdm = () => {
    setUserEdit({
      ...userEdit,
      is_admin: !userEdit.is_admin
    });
  };

  const handleChangeAti = () => {
    setUserEdit({
      ...userEdit,
      ativo: !userEdit.ativo
    });
  };

  return (
    <div className="mb-3 p-3">
      <Accordion
        expanded={openAccordion}
        onChange={() => setOpenAccordion(prev => !prev)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <h5 className='reconect-text'>Cadastro de Usuários</h5>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={submit}>
            <div className="row">
              <div className="col-xs-12 col-md-4 mb-2">
                <TextField
                  label="Nome"
                  variant="outlined"
                  fullWidth
                  value={userEdit.nome}
                  onChange={ e => setUserEdit({...userEdit,nome:e.target.value}) }
                  required
                  color="primary"
                  inputProps={{ maxLength: 50 }}
                />
              </div>
              <div className="col-xs-12 col-md-4 mb-2">
                <TextField
                  label="Login"
                  variant="outlined"
                  fullWidth
                  value={userEdit.login}
                  onChange={ e => setUserEdit({...userEdit,login:e.target.value}) }
                  required
                  color="primary"
                  inputProps={{ maxLength: 20 }}
                />
              </div>
              <div className="col-xs-12 col-md-4 mb-4">
                <TextField
                  label="Senha"
                  variant="outlined"
                  fullWidth
                  value={userEdit.senha}
                  onChange={ e => setUserEdit({...userEdit,senha:e.target.value}) }
                  required
                  color="primary"
                  inputProps={{ maxLength: 20 }}
                />
              </div>
              <div className="col-12 mb-2 row">
                <div className="col-md-4 col-xs-12 mb-4" style={{ alignContent: "center", justifyItems: "center" }}>
                  <Typography className="reconect-training-title-infos">É funcionário?</Typography>
                  <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                    <Typography>NÃO</Typography>
                    <AntSwitch inputProps={{ 'aria-label': 'ant design' }} checked={userEdit.is_funcionario} onChange={handleChangeFunc} />
                    <Typography>SIM</Typography>
                  </Stack>
                </div>
                <div className="col-md-4 col-xs-12 mb-4" style={{ alignContent: "center", justifyItems: "center" }}>
                  <Typography className="reconect-training-title-infos">É adiministrador?</Typography>
                  <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                    <Typography>NÃO</Typography>
                    <AntSwitch inputProps={{ 'aria-label': 'ant design' }} checked={userEdit.is_admin} onChange={handleChangeAdm} />
                    <Typography>SIM</Typography>
                  </Stack>
                </div>
                <div className="col-md-4 col-xs-12 mb-4" style={{ alignContent: "center", justifyItems: "center" }}>
                  <Typography className="reconect-training-title-infos">Esta ativo?</Typography>
                  <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                    <Typography>NÃO</Typography>
                    <AntSwitch inputProps={{ 'aria-label': 'ant design' }} checked={userEdit.ativo} onChange={handleChangeAti} />
                    <Typography>SIM</Typography>
                  </Stack>
                </div>
              </div>
            </div>
            <div className="col-12 mb-4">
              <Button
                size="small"
                type="submit"
                color="success"
                startIcon={<SaveIcon />}
                variant="contained"
                style={{ float: "right", width: "120px" }}
              >
                Salvar
              </Button>
              <Button
                size="small"
                color="error"
                startIcon={<ClearIcon />}
                variant="contained"
                style={{ float: "left", width: "120px" }}
                onClick={() => cancelEdit()}
              >
                Cancelar
              </Button>
            </div>
          </form>
        </AccordionDetails>
      </Accordion>
      
      {/* 🔥 TABELA DAS USUÁRIOS */}

      <h5 className='reconect-text mt-4'>USUÁRIOS CADASTRADOS</h5>

      <TableContainer component={Paper} className="mt-3">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Nome</strong></TableCell>
              <TableCell><strong>Login</strong></TableCell>
              <TableCell><strong>Funcionário?</strong></TableCell>
              <TableCell><strong>Administrador?</strong></TableCell>
              <TableCell><strong>Ativo?</strong></TableCell>
              <TableCell><strong>Ações</strong></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {(users ?? []).map(u => (
              <TableRow key={u.id}>
                <TableCell>{u.nome}</TableCell>
                <TableCell>{u.login}</TableCell>
                <TableCell style={{ color: u.is_funcionario ? "green" : "red" }}>
                  {u.is_funcionario ? "Sim" : "Não"}
                </TableCell>
                <TableCell style={{ color: u.is_admin ? "green" : "red" }}>
                  {u.is_admin ? "Sim" : "Não"}
                </TableCell>
                <TableCell style={{ color: u.ativo ? "green" : "red" }}>
                  {u.ativo ? "Sim" : "Não"}
                </TableCell>

                <TableCell>
                  <Button
                    size="small"
                    color="primary"
                    startIcon={<EditIcon />}
                    onClick={() => handleEdit(u)}
                    style={{ minWidth: "105px" }}
                  >
                    Editar
                  </Button>
                  <Button
                    size="small"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={() => handleDelete(u.id)}
                    style={{ minWidth: "105px" }}
                  >
                    Excluir
                  </Button>
                </TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Alerts 
        openSnack={openSnack}
        setWhenOpen={setOpenSnack}
        type={snackType}
        msg={snackMsg}
      />
      <AlertDialog 
        openDialog={openDialog}
        title={titleDialog}
        msg={mensagem}
        showDialog={setOpenDialog}
        confirmCase={() => confirmDelete(idForDelete)}
      />
    </div>
  );
}
